<form [formGroup]="userForm" (keydown.enter)="saveUser()">
  <div class="access-section">
    <h3>Zugangsdaten</h3>

    <div class="input-columns-container">
      <div class="input-column">
        <mat-form-field appearance="fill">
          <mat-label>Nutzername</mat-label>
          <input matInput placeholder="mmustermann" formControlName="username">
        </mat-form-field>

        @if (authService.isAdmin()) {
          <mat-form-field appearance="fill">
            <mat-label>Nutzertyp</mat-label>
            <mat-select formControlName="type">
              @for (userType of userTypes; track userType) {
                <mat-option [value]="userType.type">
                  {{userType.label}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>

      <div class="input-column">
        @if (!showPasswordHint) {
          <mat-form-field appearance="fill">
            <mat-label>Neues Passwort</mat-label>
            <input matInput placeholder="*******" formControlName="newPassword" [type]="hidePassword ? 'password' : 'text'">
            <mat-icon matSuffix (click)="switchPasswordVisibility($event)">
              {{hidePassword ? 'visibility_off' : 'visibility'}}
            </mat-icon>
          </mat-form-field>
        }

        @if (!showPasswordHint) {
          <mat-form-field appearance="fill">
            <mat-label>Passwort bestätigen</mat-label>
            <input matInput placeholder="*******" formControlName="confirmNewPassword" [type]="hidePassword ? 'password' : 'text'">
            <mat-icon matSuffix (click)="switchPasswordVisibility($event)">
              {{hidePassword ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            @if (userForm.hasError('matching')) {
              <mat-error>Passwörter stimmen nicht überein.</mat-error>
            }
          </mat-form-field>
        }

        @if (showPasswordHint) {
          <span>Der neue Nutzer kann sein Passwort mit der Funktion "Passwort zurücksetzen" setzen.</span>
        }
      </div>
    </div>
  </div>

  <div class="personal-section">
    <h3>Persönliche Daten</h3>

    <div class="input-columns-container" formGroupName="person">
      <div class="input-column">
        <mat-form-field appearance="fill">
          <mat-label>Vorname</mat-label>
          <input matInput placeholder="Max" formControlName="firstName">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Nachname</mat-label>
          <input matInput placeholder="Mustermann" formControlName="lastName">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>E-Mail</mat-label>
          <input matInput placeholder="max@mustermann.de" formControlName="mail">
        </mat-form-field>
      </div>

      <div class="input-column">
        <mat-form-field appearance="fill">
          <mat-label>Telefon</mat-label>
          <input matInput placeholder="0049 201 776644" formControlName="phone">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Handy</mat-label>
          <input matInput placeholder="0049 157 776644" formControlName="cell">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Fax</mat-label>
          <input matInput placeholder="0049 201 776644" formControlName="fax">
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="form-action-row">
    @if (showCancel) {
      <button mat-flat-button (click)="cancel()">
        Abbrechen
      </button>
    }

    <button mat-flat-button color="primary" class="save-btn"
      [disabled]="userForm.pristine || userForm.invalid" (click)="saveUser()">
      Speichern
      <mat-icon>save</mat-icon>
    </button>
  </div>
</form>
